export default __webpack_public_path__ + "static/media/BearPage2.263dd02b.txt";